import { Injectable } from '@angular/core';
import { MatLegacyDialog } from '@angular/material/legacy-dialog';
import { Observable } from 'rxjs';

import { DialogConfig } from '../../shared/configs';
import { SalesOrderFormComponent } from '../components/sales-order-form/sales-order-form.component';

@Injectable({ providedIn: 'root' })
export class SalesOrderActionsHelperService {
  constructor(private legacyDialog :MatLegacyDialog) {}

  createOrder() :Observable<any> {
    return this.#openForm();
  }

  editOrder(salesOrderId :number) :Observable<any> {
    return this.#openForm(salesOrderId);
  }

  /**
   * @param salesOrderId - The ID of the sales order to edit
   * @returns An observable that emits the response from the create/update request
   */
  #openForm(salesOrderId ?:number) :Observable<any> {
    return this.legacyDialog
      .open(SalesOrderFormComponent, {
        ...DialogConfig.XX_LARGE,
        panelClass: 'sales-order-form-dialog',
        data: { salesOrderId },
      })
      .afterClosed();
  }
}
